var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.serial)?_c('h5',[_c('strong',[_vm._v("Part Number:")]),_vm._v(" "+_vm._s(_vm.serial))]):_vm._e(),_c('b-progress',{attrs:{"value":_vm.progressStep,"max":_vm.progressMax,"animated":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }